export default "__VITE_ASSET__BG1E4C3e__"